export default __webpack_public_path__ + "static/media/step-c-1.78ceb8d2.png";